/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * @module bulb-image-carousel/bulbimagecarousel
 */

import { Plugin } from 'ckeditor5';
import BulbImageCarouselEditing from './bulbimagecarouselediting';
import BulbImageCarouselUI from './bulbimagecarouselui';
import BulbImageCarouselToolbar from './bulbimagecarouseltoolbar';
import BulbImageCarouselAddSlideUI from './carousel-add-slide/bulbimagecarouseladdslideui';
import BulbImageCarouselRemoveSlideUI from './carousel-remove-slide/bulbimagecarouselremoveslideui';

/**
 * The image carousel plugin for Bulb's CKEditor.
 *
 * @extends Plugin
 */
export default class BulbImageCarousel extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbImageCarouselEditing, BulbImageCarouselUI, BulbImageCarouselToolbar, BulbImageCarouselAddSlideUI,
      BulbImageCarouselRemoveSlideUI] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbImageCarousel' as const;
  }
}
